module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nyx-aa528e229d568a3d0875d56e7c584c69.png";